import Default from "../default-page";

export default class Home extends Default {
  ui = {
    ...Default.ui,
    slider: ".js-heroSlider[0]",
  };
  events = {
    ...Default.events,
  };

  constructor(props) {
    super(props);
  }

  initilized() {
    this.el.classList.add("is-loaded");
  }
}
